import { Col } from "v2/components/base/Flex/ui";

const TabBody = ({
  index,
  selectedTab,
  children,
  ...props
}: {
  index: number;
  selectedTab: number;
  children: React.ReactNode;
} & any) => {
  const { sx, ...rest } = props;
  const isActive = index === selectedTab;

  return (
    <Col
      sx={{
        opacity: isActive ? 1 : 0,
        pointerEvents: isActive ? "auto" : "none",
        height: isActive ? "auto" : 0,
        overflow: "hidden",
        transition: "opacity 0.3s ease-in-out, height 0.3s ease-in-out",
        ...sx,
      }}
      {...rest}>
      {children}
    </Col>
  );
};

export default TabBody;
